import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-16 bg-gray-50 px-4" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        <div className="text-center mb-12" data-id="element-62">
          <div className="inline-flex items-center justify-center p-3 bg-red-100 rounded-full mb-4" data-id="element-63">
            <AlertTriangle className="w-8 h-8 text-red-600" data-id="element-64" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-65">
            😩 Si estás estudiando Anatomía, probablemente te pasa esto:
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10 border border-gray-100" data-id="element-66">
          <ul className="space-y-6" data-id="element-67">
            {['Lees apuntes largos y no logras retener la información', 'Memorizar nombres y estructuras se vuelve agotador', 'No tienes claro qué entra en el examen y qué no', 'Estudias muchas horas, pero los resultados no acompañan', 'Llegas a parciales y finales con dudas, ansiedad y confusión'].map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-68">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-69" />
                <span className="text-lg text-gray-700 font-medium" data-id="element-70">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-71">
            <div className="bg-blue-50 rounded-xl p-6 text-center space-y-3" data-id="element-72">
              <p className="text-xl font-bold text-blue-900" data-id="element-73">
                👉 El problema no es que no estudies lo suficiente.
              </p>
              <p className="text-xl font-bold text-red-600" data-id="element-74">
                👉 El problema es cómo estás estudiando Anatomía.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}